// Ensemble bg-scene sizer.
//
// The scene atom (atoms/_stickyBgScene.twig) is rendered as a preceding
// sibling of .wn-ensemble-block. It has 0 net flow contribution, so the
// pattern's natural Y in the document equals .wn-ensemble-block.top.
//
// Per Figma the textured pattern should disengage halfway through the
// ensemble photos (not at the bottom of the block). The 70vh inline
// fallback from the Twig atom drifts on tall / short viewports because
// the photo size is fixed in px while vh changes. Measure instead.
//
//   patternHeight = (photo.top - block.top) + (photo.height / 2)
//
// Re-runs on resize and on each ensemble image's `load` event so the
// height stays correct as intrinsic image dimensions resolve.

const SELECTOR_BLOCK = '.wn-ensemble-block'
const SELECTOR_PHOTO = '.wn-actor-card__photo'
const SELECTOR_PATTERN = '[data-scene-pattern]'
const SELECTOR_VIDEO = '[data-scene-video]'
const VIDEO_HEIGHT_VH = 100

function findSceneFor(block) {
    // Walk backward from .wn-ensemble-block (or its wrapping
    // block-anchor) to find the pattern + video atoms rendered just
    // before it.
    const anchor = block.closest('.block-anchor') || block
    let pattern = null
    let video = null
    let prev = anchor.previousElementSibling
    while (prev) {
        if (!video && prev.matches(SELECTOR_VIDEO)) video = prev
        else if (prev.matches(SELECTOR_PATTERN)) { pattern = prev; break }
        prev = prev.previousElementSibling
    }
    return { pattern, video }
}

function position(block) {
    const { pattern, video } = findSceneFor(block)
    if (!pattern || !video) return

    const firstPhoto = block.querySelector(SELECTOR_PHOTO)
    if (!firstPhoto) return

    const blockRect = block.getBoundingClientRect()
    const photoRect = firstPhoto.getBoundingClientRect()
    if (blockRect.height <= 0 || photoRect.height <= 0) return

    // Distance from the block's top to the vertical centre of the
    // first photo row.
    const h = Math.round((photoRect.top - blockRect.top) + photoRect.height / 2)
    if (h <= 0) return

    // Apply pattern height + flow-canceling margins. No shift needed:
    // the pattern's natural Y already aligns with .wn-ensemble-block.top.
    pattern.style.height = `${h}px`
    pattern.style.marginTop = '0px'
    pattern.style.marginBottom = `${-h}px`
    video.style.marginTop = `${h}px`
    video.style.marginBottom = `calc(-${VIDEO_HEIGHT_VH}vh - ${h}px)`
}

const wnEnsembleBgScene = {
    init() {
        const block = document.querySelector(SELECTOR_BLOCK)
        if (!block) return

        const run = () => position(block)
        // Run once on init and again after a frame so layout settles.
        run()
        window.requestAnimationFrame(run)

        // Debounced resize — drag-resizing shouldn't trigger a flurry
        // of partial recomputes mid-layout.
        let resizeTimer
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer)
            resizeTimer = setTimeout(run, 150)
        })

        // Re-run as each photo's intrinsic dimensions resolve.
        block.querySelectorAll('img').forEach((img) => {
            if (!img.complete) {
                img.addEventListener('load', run, { once: true })
            }
        })
    },
}

export default wnEnsembleBgScene
